import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "select-date-roster" }
const _hoisted_2 = { style: {"min-height":"20vh"} }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = {
  class: "w-full",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_5 = { class: "flex w-full items-center justify-between" }
const _hoisted_6 = { class: "text-2xl font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = { class: "text-sm font-normal" }
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = { class: "mb-8" }
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Pilih Tanggal'), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalDefault, {
      show: _ctx.showModal,
      onHideDialog: _ctx.closeDialog
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.headerLabel), 1),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.headerDescription), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.dateRange,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
                  modelModifiers: { range: true },
                  masks: {
                  input: 'YYYY-MM-DD'
                },
                  minDate: new Date()
                }, {
                  default: _withCtx(({ togglePopover, inputValue }) => [
                    _createVNode(_component_InputText, {
                      id: "end-date",
                      placeholder: "Masukkan tanggal",
                      value: inputValue.start && inputValue.end ? `${_ctx.moment(inputValue.start).format('DD MMMM YYYY')} - ${_ctx.moment(inputValue.end).format('DD MMMM YYYY')}` : null,
                      class: _normalizeClass(`input-default`),
                      onClick: togglePopover,
                      readonly: true
                    }, null, 8, ["value", "onClick"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "minDate"]),
                (_ctx.showErrorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString('Tanggal tidak boleh kosong')))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  class: "mb-2 sm:mb-0 flex gap-2 w-full",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange.start && _ctx.dateRange.end ? _ctx.setDaterange() : _ctx.showError()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onHideDialog"])
  ]))
}